// src/config/microsoft.js
export const MICROSOFT_CONFIG = {
  clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID,
  clientSecret: process.env.REACT_APP_MICROSOFT_CLIENT_SECRET, // for web token exchange
  redirectUri: process.env.REACT_APP_MICROSOFT_REDIRECT_URI,
  scopes: process.env.REACT_APP_MICROSOFT_SCOPES?.split(' '),
  authEndpoint: process.env.REACT_APP_MICROSOFT_AUTH_ENDPOINT,
  tokenEndpoint: process.env.REACT_APP_MICROSOFT_TOKEN_ENDPOINT,
};
